import React from 'react'
import Google from "../../components/assets/google.png"
import Apple from "../../components/assets/apple.png"
function Footer() {
  return (
    <div>
            <div className="footer footer-first-row">
        <div className="container">
          <div className="row">
            <div className="col-md-6 col-sm-6">
              <ul className="call-email-alt">
                <li><a href={`tel: 1800-000-000`} className="callemail"><i className="uil uil-dialpad-alt" />1800-000-000</a></li>
                <li><a href={`mailto: sales@dotdelivery.com`} className="callemail"><i className="uil uil-envelope-alt" /><span className="__cf_email__" data-cfemail="3b52555d547b5c5a565954484e4b5e49565a49505e4f15585456">sales@dotdelivery.com</span></a></li>
              </ul>
            </div>
            <div className="col-md-6 col-sm-6">
              <div className="social-links-footer">
                <ul>
                  <li><a href="#"><i className="fab fa-facebook-f" /></a></li>
                  <li><a href="#"><i className="fab fa-twitter" /></a></li>
                  {/* <li><a href="#"><i className="fab fa-google-plus-g" /></a></li> */}
                  {/* <li><a href="#"><i className="fab fa-linkedin-in" /></a></li> */}
                  <li><a href="#"><i className="fab fa-instagram" /></a></li>
                  {/* <li><a href="#"><i className="fab fa-pinterest-p" /></a></li> */}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    <section className="footer1 pt-5 pb-5">
      <div className="container">
        <div className="row">
          <div className="col-md-4 col-12 col-sm-12">
            <h6 className="mb-3">Subscribe to our Newsletter</h6>
            <form className="newsletter-form mb-1">
              <div className="input-group">
                <input type="text" placeholder="Please enter your email" className="form-control" />
                <div className="input-group-append">
                  <button type="button" className="btn btn-primary">
                    Subscribe
                  </button>
                </div>
              </div>
            </form>
            <p> to get updates on <a href="offers.html">Offers and Coupons</a></p>
            <div className="app">
              <p className="mb-2">DOWNLOAD APP</p>
              <a href="#">
                <img className="img-fluid" src={Google} />
              </a>
              <a href="#">
                <img className="img-fluid" src={Apple} />
              </a>
            </div>
          </div>
          <div className="col-md-1 col-sm-6 mobile-none">
          </div>
          <div className="col-md-2 col-6 col-sm-4">
            <h6 className="mb-3">About Dot Delivery</h6>
            <ul>
              <li><a href="#">About Us</a></li>
              <li><a href="#">Culture</a></li>
              <li><a href="#">Blog</a></li>
              <li><a href="#">Careers</a></li>
              <li><a href="#">Contact</a></li>
            </ul>
          </div>
          <div className="col-md-2 col-6 col-sm-4">
            <h6 className="mb-3">For Foodies</h6>
            <ul>
              <li><a href="#">Community</a></li>
              <li><a href="#">Developers</a></li>
              <li><a href="#">Blogger Help</a></li>
              <li><a href="#">Verified Users</a></li>
              <li><a href="#">Code of Conduct</a></li>
            </ul>
          </div>
          <div className="col-md-2 m-none col-4 col-sm-4">
            <h6 className="mb-3">For Restaurants</h6>
            <ul>
              <li><a href="#">Advertise</a></li>
              <li><a href="#">Add a Restaurant</a></li>
              {/* <li><a href="#">Claim your Listing</a></li> */}
              <li><a href="#">For Businesses</a></li>
              <li><a href="#">Owner Guidelines</a></li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <footer className="pt-4 pb-4 text-center">
      <div className="container">
        <p className="mt-0 mb-0">© Copyright 2022 Dot Delivery. All Rights Reserved</p>
        {/* <small className="mt-0 mb-0"> Made with <i className="fas fa-heart heart-icon text-danger" /> by
          <a className="text-danger" target="_blank" href="https://laughing-darwin-c668f3.netlify.app/"> Jessy U. Bandya</a> 
        </small> */}
      </div>
    </footer>
  </div>
  )
}

export default Footer